import { render, staticRenderFns } from "./ActiveModelStateChip.vue?vue&type=template&id=a124200c&scoped=true"
import script from "./ActiveModelStateChip.vue?vue&type=script&lang=js"
export * from "./ActiveModelStateChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a124200c",
  null
  
)

export default component.exports